import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import RowNoData from '@/components/elements/RowNoData';
import { GetLibroFavorito } from '@/objects/Articles';
import RowNotificacionesFavoritos from '@/components/elements/listas/lista_notificaciones/RowNotificacionesFavoritos';

const LIMIT_NOTIFICACIONES = 50;
function MensajesNotificaciones() {

    const { articulosQueries } = useServices();

    const [notificaciones, setNotificaciones] = React.useState<GetLibroFavorito[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        cargarNotificaciones();
    }, []);

    function cargarNotificaciones() {
        const datosUsuario = cargarDatosUsuario();
        articulosQueries?.getLibrosSonFavoritos(Number(datosUsuario?.id_user), LIMIT_NOTIFICACIONES).then((response: AxiosResponse<GetLibroFavorito[]>) => {
            setNotificaciones(response.data);
        }).catch((error: any) => {
        });
    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                {notificaciones.length > 0 ? notificaciones.map((notificacion: GetLibroFavorito, index: number) => {
                    return (
                        <section style={{ display: 'flex', flexDirection: 'column', width: "100%", margin: "10px", alignItems: "center" }} key={index}>
                            <RowNotificacionesFavoritos notificacionGetLibroFavorito={notificacion} t={t} />
                        </section>
                    );
                }) : <RowNoData texto={t("menu:secciones.mensajes.no_hay_mensajes")} />}
            </section>
        </section>
    );
}

export default MensajesNotificaciones;